export default __webpack_public_path__ + "static/media/pictogramBeaconCelebration128.73af46cf.svg";